/* eslint-disable */
/**
 * This file was automatically generated by typeshare from Rust.
 * Do not edit this file manually.
 *
 * To regenerate, run: pnpm generate-types
 */

/*
 Generated by typeshare 1.13.3
*/

export enum Currency {
  BTC = 'btc',
  EUR = 'eur',
  USDT = 'usdt',
  DAI = 'dai',
  USD = 'usd',
  AED = 'aed',
  ARS = 'ars',
  AUD = 'aud',
  BDT = 'bdt',
  BGN = 'bgn',
  BOB = 'bob',
  BRL = 'brl',
  CAD = 'cad',
  CHF = 'chf',
  CLP = 'clp',
  CNY = 'cny',
  COP = 'cop',
  CRC = 'crc',
  CZK = 'czk',
  DKK = 'dkk',
  DOP = 'dop',
  EGP = 'egp',
  FJD = 'fjd',
  GBP = 'gbp',
  HKD = 'hkd',
  HRK = 'hrk',
  HUF = 'huf',
  IDR = 'idr',
  ILS = 'ils',
  INR = 'inr',
  JPY = 'jpy',
  KES = 'kes',
  KRW = 'krw',
  LKR = 'lkr',
  MAD = 'mad',
  MXN = 'mxn',
  MYR = 'myr',
  NGN = 'ngn',
  NOK = 'nok',
  NZD = 'nzd',
  PEN = 'pen',
  PHP = 'php',
  PKR = 'pkr',
  PLN = 'pln',
  QAR = 'qar',
  RON = 'ron',
  RUB = 'rub',
  SAR = 'sar',
  SEK = 'sek',
  SGD = 'sgd',
  THB = 'thb',
  TRY = 'try',
  TWD = 'twd',
  UAH = 'uah',
  VND = 'vnd',
  ZAR = 'zar',
}

export interface AccountMovement {
  id: string;
  user_id?: string;
  amount: number;
  currency: Currency;
  features: string;
  created_at: string;
  token_id?: string;
}

export interface AccountMovementsResponse {
  data: AccountMovement[];
  total: number;
}

/**
 * Standard API error response used across all services.
 *
 * Frontend expects: `{ "error": "code", "action": null | "hint", "message": "text" }`
 */
export interface ApiErrorResponse {
  /** Machine-readable error code (e.g., "not_found", "insufficient_funds") */
  error: string;
  /** Suggested client action (e.g., "add_credits", "retry_later") */
  action?: string;
  /** Human-readable error message */
  message: string;
}

export interface ApiKey {
  id: string;
  user_id: string;
  name: string;
  key_hash: string;
  scope?: any;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  expires_at: string;
}

export interface ApiKeyCreateRequest {
  name: string;
  scope?: string[];
  expires_in_days: number;
}

export interface ApiKeyResponse {
  id: string;
  name: string;
  scope?: string[];
  is_active: boolean;
  created_at: string;
  expires_at: string;
  key?: string;
}

export interface ApiKeyUpdateRequest {
  name?: string;
  is_active?: boolean;
  scope?: string[];
}

export interface ApiKeyUsageResponse {
  total_spent: number;
  currency: Currency;
  transaction_count: number;
  first_used: string;
  last_used: string;
}

/** Request body for exchanging an authorization code for tokens */
export interface AuthCodeExchangeRequest {
  code: string;
}

/**
 * Login-success response for **browser** clients. The opaque session token is
 * delivered via the `__Secure-session` cookie (set by the handler with
 * [`crate::sessions::cookies::set_session_cookie`]) and therefore does NOT
 * appear in the body. The body carries only the short-lived access token plus
 * the minimum identity claims the SPA needs to render its post-login state.
 *
 * Split-token sessions: no `refresh_token` in the body — refresh is a
 * server-side concern keyed on the cookie. The SPA reads
 * `access_token_expires_at` exclusively.
 */
export interface BrowserLoginSuccess {
  user_id: string;
  access_token: string;
  access_token_expires_at: string;
  /**
   * Optional identity claims forwarded from the IdP / our user record. Used
   * by the SPA to populate the account widget without an extra round trip.
   */
  email?: string;
  display_name?: string;
}

export interface CommonQueryParams {
  limit?: number;
  offset?: number;
}

/**
 * JSON-serializable response body for HTTP 429 when concurrency cap is hit.
 * Public type so consumers (and typeshare-generated frontend types) share
 * the shape.
 */
export interface ConcurrencyLimitError {
  /** Machine-readable error code. */
  error: string;
  /** User-facing message suitable for direct display. */
  message_user_facing: string;
  /** Suggested retry delay in seconds. */
  retry_after_seconds: number;
  /** Number of streams currently active for this principal. */
  current_streams: number;
  /** Configured cap for this principal. */
  max_streams: number;
}

export interface CustomerPortalResponse {
  portal_url: string;
}

export enum DepositStatus {
  PENDING = 'PENDING',
  DONE = 'DONE',
  ERROR = 'ERROR',
}

export enum DepositProvider {
  STRIPE = 'STRIPE',
  COINBASE = 'COINBASE',
}

export interface Deposits {
  id: string;
  user_id?: string;
  amount: number;
  currency: Currency;
  status: DepositStatus;
  account_movements_id?: string;
  data: string;
  created_at: string;
  updated_at: string;
  provider: DepositProvider;
}

export interface DepositsResponse {
  data: Deposits[];
  total: number;
}

export interface EmailVerificationRequest {
  id: string;
  email_id: string;
}

export interface FieldValidationError {
  field: string;
  code: string;
  message: string;
  params: any;
}

export interface FieldValidationErrorResponse {
  error: string;
  action?: string;
  message: string;
  errors: FieldValidationError[];
}

export interface GitHubLoginChallenge {
  auth_url: string;
  referral_code?: string;
}

export interface GitHubLoginChallengeResponse {
  code: string;
  state: string;
  scope?: string;
}

export interface GitHubLoginRequest {
  referral_code?: string;
}

export interface GoogleLoginChallenge {
  auth_url: string;
  referral_code?: string;
}

export interface GoogleLoginChallengeResponse {
  code: string;
  state: string;
  scope?: string;
  authuser?: string;
  prompt?: string;
}

export interface GoogleLoginRequest {
  referral_code?: string;
}

export interface HttpNewVerifiedEmail {
  email: string;
}

export interface HttpRetryVerifiedEmail {
  verified_email_id: string;
}

/** Enum representing supported 2FA methods */
export enum TwoFactorMethodType {
  Totp = 'totp',
  Webauthn = 'webauthn',
}

/** Info about an available 2FA method */
export interface TwoFactorMethodInfo {
  /** Unique ID of this method */
  id: string;
  /** Method type (totp, webauthn) */
  method_type: TwoFactorMethodType;
  /** User-given name for this method */
  name: string;
}

/** Response when 2FA is required to complete login */
export interface LoginPending2FA {
  /** Short-lived token for 2FA verification */
  pending_token: string;
  /** Available 2FA methods for this user */
  available_methods: TwoFactorMethodInfo[];
  /** Expiration timestamp (unix seconds) */
  expires_at: number;
  /** Whether recovery codes are available */
  has_recovery_codes: boolean;
}

export interface MagicLinkLoginChallenge {
  id: string;
  email: string;
  challenge: string;
  referral_code?: string;
}

export interface MagicLinkLoginChallengeResponse {
  id: string;
  challenge: string;
}

export interface MagicLinkLoginReqest {
  email: string;
  referral_code?: string;
}

export interface MicrosoftLoginChallenge {
  auth_url: string;
  referral_code?: string;
}

export interface MicrosoftLoginChallengeResponse {
  code: string;
  state: string;
  scope?: string;
  session_state?: string;
}

export interface MicrosoftLoginRequest {
  referral_code?: string;
}

/**
 * Login-success response for **native SDK / CLI** clients. Same shape as
 * [`BrowserLoginSuccess`] but with the raw opaque session token in the body —
 * native clients can't receive cookies so they store the token themselves and
 * pass it back on subsequent requests via the configured transport (typically
 * an Authorization header in the SDK's own framing, not the bearer header
 * used for the access token).
 */
export interface NativeLoginSuccess {
  user_id: string;
  access_token: string;
  access_token_expires_at: string;
  /**
   * Opaque session token (`gf_...`). Present when a token was issued or
   * rotated; omitted on a no-rotation refresh, where the client keeps its
   * existing token. The client MUST store it securely (OS keyring /
   * encrypted preferences) — losing it forces re-authentication.
   */
  session_token?: string;
  email?: string;
  display_name?: string;
}

export interface NewDepositCoinbaseResponse {
  deposit_id: string;
  charge_id: string;
  hosted_url: string;
}

export interface NewDepositHttp {
  /** Amount in cents (e.g., 1500 for 15.00 EUR, 1 for 0.01 EUR) */
  amount: number;
  currency: Currency;
  provider: DepositProvider;
}

export interface NewDepositStripeResponse {
  deposit_id: string;
  checkout_session_id: string;
  checkout_url: string;
}

export interface NewSubscriptionCheckoutResponse {
  checkout_session_id: string;
  redirect_url: string;
}

export interface NostrLoginChallenge {
  id: string;
  public_key: string;
  challenge: string;
  referral_code?: string;
}

export interface NostrLoginChallengeResponse {
  id: string;
  response: string;
}

export interface NostrLoginRequest {
  public_key: string;
  referral_code?: string;
}

export interface OidcLoginChallenge {
  /** The URL the frontend should redirect to (Hydra's `/oauth2/auth`). */
  auth_url: string;
  referral_code?: string;
}

export interface OidcLoginChallengeResponse {
  /**
   * Auth code returned by the IdP on a successful authorize. Absent when
   * the IdP redirects back with an error (`?error=...&state=...`).
   */
  code?: string;
  /**
   * State (CSRF token) for verification. Always present so we can identify
   * and clean up the cached challenge.
   */
  state: string;
  scope?: string;
  /**
   * Error code per RFC 6749 §4.1.2.1 (e.g. `access_denied`,
   * `login_required`) when the IdP could not return a code.
   */
  error?: string;
  /**
   * Human-readable error description. Attacker-controlled — log
   * server-side, never echo into redirect URLs.
   */
  error_description?: string;
  /**
   * RFC 9207 authorization-response `iss`. When present we check it against
   * the configured issuer in the link/step-up callbacks (defense-in-depth
   * on the public callback).
   */
  iss?: string;
}

export interface OidcLoginRequest {
  referral_code?: string;
  /**
   * Optional absolute URL the OIDC callback should redirect to after the
   * flow completes, instead of the default `/#/login/callback?...`. Used by
   * the refresh-on-return flow to land the user back on the same account
   * page they came from. The frontend MUST pass a URL whose origin matches
   * the configured frontend; the backend validates before honouring.
   */
  return_to?: string;
}

export interface PlanAllowance {
  service: string;
  limit: number;
}

/** Recovery codes count response */
export interface RecoveryCodesCount {
  /** Number of remaining unused recovery codes */
  remaining: number;
  /** Total number of codes generated */
  total: number;
}

/** Recovery codes regeneration response */
export interface RecoveryCodesResponse {
  /** New recovery codes (only shown once!) */
  codes: string[];
  /** Number of codes generated */
  count: number;
}

export interface ReferralCodeResponse {
  code: string;
  created_at: string;
}

export interface ReferralEarning {
  currency: Currency;
  amount: number;
}

export interface ReferralHistoryItem {
  created_at: string;
  first_payment_processed: boolean;
  bonus_amount?: number;
  bonus_currency?: Currency;
  bonus_date?: string;
}

export interface ReferralHistoryResponse {
  data: ReferralHistoryItem[];
  total: number;
}

export interface ReferralStatsResponse {
  total_referrals: number;
  successful_referrals: number;
  total_earnings: ReferralEarning[];
}

/**
 * Body of `POST /v1/login/refresh`. Browsers send no body — the session
 * cookie is read directly from the request. Native SDK / CLI clients
 * POST `{ "session_token": "gf_..." }`; the field is optional so the
 * endpoint handler can still try the cookie + Authorization header before
 * falling back to the body.
 */
export interface RefreshSessionRequest {
  session_token?: string;
}

export interface SubscribeRequest {
  plan_id: string;
}

export interface SubscriptionPlanConfig {
  id: string;
  name: string;
  price: number;
  currency: Currency;
  is_free_plan: boolean;
  allowances: PlanAllowance[];
  features: string[];
  stripe_product_id?: string;
  stripe_price_id?: string;
  max_retention_days?: number | null;
}

export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  GracePeriod = 'GracePeriod',
  EXPIRED = 'EXPIRED',
  CANCELLED = 'CANCELLED',
}

export interface SubscriptionResponse {
  subscription_id: string;
  plan_name: string;
  plan_id: string;
  is_free_plan: boolean;
  status: SubscriptionStatus;
  current_period_start: string;
  current_period_end: string;
  next_plan_id?: string;
}

/** Response for TOTP setup (contains QR code data) */
export interface TotpSetupResponse {
  /** Base32 secret for manual entry */
  secret: string;
  /** URI for QR code generation (otpauth:// format) */
  otpauth_uri: string;
  /** Token to verify setup completion */
  setup_token: string;
  /** Expiration timestamp for the setup token */
  expires_at: number;
}

/** Response after successful 2FA setup (includes recovery codes) */
export interface TwoFactorSetupComplete {
  /** Whether setup was successful */
  success: boolean;
  /** Recovery codes (only shown once!) */
  recovery_codes: string[];
  /** ID of the created 2FA method */
  method_id: string;
}

/** 2FA status response */
export interface TwoFactorStatus {
  /** Whether 2FA is enabled */
  enabled: boolean;
  /** List of enabled methods */
  methods: TwoFactorMethodInfo[];
  /** Number of remaining recovery codes */
  recovery_codes_remaining: number;
}

export interface UsageResponse {
  service: string;
  used: number;
  limit: number;
  remaining: number;
}

export interface VerifiedEmail {
  id: string;
  user_id: string;
  email: string;
  is_verified: boolean;
  last_requested_at: string;
  request_count: number;
  created_at: string;
  updated_at: string;
  is_account_email: boolean;
}

export interface VerifiedEmailsQueryParams {
  limit?: number;
  offset?: number;
  is_verified?: boolean;
}

export interface VerifiedEmailsResponse {
  data: VerifiedEmail[];
  total: number;
}

/** Request to verify 2FA code during login */
export interface Verify2FALoginRequest {
  /** The pending token from LoginPending2FA response */
  pending_token: string;
  /** The 6-digit TOTP code or recovery code */
  code: string;
}

export interface VerifyEmailResponse {
  email_id: string;
  verify_email_token: string;
}

/**
 * Fresh identity claims for the authenticated user. Returned by
 * `GET /v1/a/whoami`. For OIDC users, populated by decrypting + parsing the
 * `id_token` stored on the session row (no IdP round-trip). For local users,
 * derived from the `users` table profile.
 */
export interface WhoamiResponse {
  user_id: string;
  email?: string;
  display_name?: string;
  picture?: string;
  /**
   * `"oidc"` for OIDC-backed sessions, `"local"` for everyone else
   * (Nostr, magic link, Google/GitHub/Microsoft OAuth — all carry a
   * locally-issued JWT and store identity locally).
   */
  login_method: string;
}

export type LoginChallenge =
  | { type: 'NOSTR'; content: NostrLoginChallenge }
  | { type: 'EMAIL_MAGIC_LINK'; content: MagicLinkLoginChallenge }
  | { type: 'GOOGLE'; content: GoogleLoginChallenge }
  | { type: 'GITHUB'; content: GitHubLoginChallenge }
  | { type: 'MICROSOFT'; content: MicrosoftLoginChallenge }
  | { type: 'OIDC'; content: OidcLoginChallenge };

export type LoginChallengeUserResponse =
  | { type: 'NOSTR'; content: NostrLoginChallengeResponse }
  | { type: 'EMAIL_MAGIC_LINK'; content: MagicLinkLoginChallengeResponse }
  | { type: 'GOOGLE'; content: GoogleLoginChallengeResponse }
  | { type: 'GITHUB'; content: GitHubLoginChallengeResponse }
  | { type: 'MICROSOFT'; content: MicrosoftLoginChallengeResponse }
  | { type: 'OIDC'; content: OidcLoginChallengeResponse };

export type LoginRequest =
  | { type: 'NOSTR'; content: NostrLoginRequest }
  | { type: 'EMAIL_MAGIC_LINK'; content: MagicLinkLoginReqest }
  | { type: 'GOOGLE'; content: GoogleLoginRequest }
  | { type: 'GITHUB'; content: GitHubLoginRequest }
  | { type: 'MICROSOFT'; content: MicrosoftLoginRequest }
  | { type: 'OIDC'; content: OidcLoginRequest };

export type NewDepositResponse =
  | { type: 'STRIPE'; content: NewDepositStripeResponse }
  | { type: 'COINBASE'; content: NewDepositCoinbaseResponse };

export type NewSubscriptionResponse =
  | { type: 'Direct'; content: SubscriptionResponse }
  | { type: 'Checkout'; content: NewSubscriptionCheckoutResponse };

/*
 Generated by typeshare 1.13.3
*/

/** Persisted on `challenge.data` and submitted back by the client. */
export interface AltchaChallengeData {
  salt: string;
  number: number;
  challenge: string;
  signature: string;
  algorithm: string;
}

/** Public challenge sent to the client. */
export interface AltchaPublicChallenge {
  salt: string;
  challenge: string;
  signature: string;
  algorithm: string;
}

export interface AverageTimeData {
  average_time_seconds: number;
}

export interface BrowserData {
  browser: string;
  count: number;
}

export enum ChallengeKind {
  ALTCHA = 'ALTCHA',
}

export interface Challenge {
  id: string;
  form_id: string;
  kind: ChallengeKind;
  data: string;
  created_at: string;
  expires_at: string;
  completed_at?: string;
}

export interface CityData {
  city: string;
  count: number;
}

export interface CountryData {
  country: string;
  count: number;
}

export interface File {
  id: string;
  form_id: string;
  message_id: string;
  filename: string;
  bucket_name: string;
  path: string;
  size: number;
  created_at: string;
}

export interface FileWithSignedUrl {
  file: File;
  signed_url: string;
  signed_url_expires_at: string;
}

export interface Form {
  id: string;
  title: string;
  user_id: string;
  filter_spam: boolean;
  redirect_url?: string;
  created_at: string;
  updated_at: string;
  check_specs: boolean;
  specs?: string;
  check_challenge: boolean;
  auto_response_enabled: boolean;
  auto_response_subject?: string;
  auto_response_text?: string;
  /** 'none' | 'server' | 'nostr' — immutable after creation. */
  encryption_mode: string;
  /**
   * 'full' (includes content) | 'notification' (link only). Forced to
   * 'notification' in nostr mode.
   */
  email_notification_type: string;
  /** 'html' | 'text' */
  email_notification_format: string;
  /** 'html' | 'text' */
  auto_response_format: string;
  /**
   * None means no auto-cleanup, and serializes as `null` rather than being
   * omitted, so the emitted TS has to admit it.
   */
  retention_days?: number | null;
  /** Empty accepts submissions from anywhere, so existing forms are unaffected. */
  allowed_origins: string[];
}

export interface FormAnalyticsAggregateResponse {
  top_countries: CountryData[];
  top_cities: CityData[];
  top_browsers: BrowserData[];
  average_time_to_submit_message: AverageTimeData;
}

export interface FormAnalyticsByDay {
  date: string;
  message_count: number;
  view_count: number;
  conversion_rate: number;
}

export interface FormAnalyticsResponse {
  from_date: string;
  to_date: string;
  message_count: number;
  view_count: number;
  conversion_rate: number;
  data: FormAnalyticsByDay[];
}

/** CSS frameworks supported for form styling and response formatting */
export enum CssFramework {
  /** Bulma CSS framework - Modern CSS framework based on Flexbox */
  Bulma = 'bulma',
  /** Bootstrap CSS framework - Popular responsive front-end framework */
  Bootstrap = 'bootstrap',
  /** Formshive custom CSS framework - Lightweight, form-focused styling */
  Formshive = 'formshive',
}

/**
 * Override options for form submission redirect behavior.
 * By default, if a redirect URL is set on the form, submissions will redirect to that URL.
 * These options allow overriding that default behavior on a per-request basis.
 */
export enum FormRedirectOverride {
  /**
   * Force redirect to a success HTML page instead of the form's configured redirect URL.
   * Useful for showing a confirmation message instead of redirecting elsewhere.
   */
  RedirectToSuccessHtml = 'html',
  /**
   * Disable any redirect and return a JSON response instead.
   * Useful for API clients or AJAX submissions that need structured response data.
   */
  NoRedirect = 'none',
}

/** Query parameters for customizing form submission behavior and HTML rendering */
export interface FormHtmlOptions {
  /**
   * CSS framework to use for styling the form response. Options: 'bulma', 'bootstrap', or 'formshive'.
   * When specified, applies framework-specific CSS classes to form elements and error messages.
   */
  css_framework?: CssFramework;
  /**
   * Whether to embed CSS styles directly in the HTML response instead of using external links.
   * Useful for self-contained HTML responses or when external CSS may not be accessible.
   */
  css_embed?: boolean;
  /**
   * Indicates if the form is being displayed within an iframe.
   * May affect how responses are formatted or styled for iframe compatibility.
   */
  iframe?: boolean;
  /**
   * Enable analytics tracking for this form submission.
   * When true, captures additional metrics like submission timing and user behavior data.
   */
  track?: boolean;
  /**
   * Override the form's default redirect behavior after successful submission.
   * Options: 'html' - Show success HTML page, 'none' - Return JSON response without redirect.
   */
  redirect?: FormRedirectOverride;
}

export interface FormRecipientsQueryParams {
  limit: number;
  offset: number;
}

export interface LocationInfo {
  country_code?: string;
  country_name?: string;
  continent_code?: string;
  continent_name?: string;
  region_code?: string;
  region_name?: string;
  city?: string;
  latitude?: number;
  longitude?: number;
  timezone?: string;
}

export interface FormView {
  id: string;
  form_id: string;
  ip_hash: string;
  user_agent?: string;
  referrer?: string;
  view_type: string;
  device_type?: string;
  browser_name?: string;
  traffic_source?: string;
  analytics_data?: any;
  created_at: string;
  location?: LocationInfo;
}

export interface FormsQueryParams {
  limit: number;
  offset: number;
}

export interface FormsRecipient {
  form_id: string;
  verified_email_id: string;
  created_at: string;
}

export interface FormsRecipientsResponse {
  data: VerifiedEmail[];
  total: number;
}

export interface FormsResponse {
  data: Form[];
  total: number;
}

export interface HttpNewForm {
  title: string;
  filter_spam?: boolean;
  check_challenge?: boolean;
  redirect_url?: string;
  auto_response_enabled?: boolean;
  auto_response_subject?: string;
  auto_response_text?: string;
  /** 'nostr' requires the user to have a Nostr public_key. */
  encryption_mode?: string;
  /** Forced to 'notification' in nostr mode. */
  email_notification_type?: string;
  email_notification_format?: string;
  auto_response_format?: string;
  /** None = use plan default. */
  retention_days?: number | null;
  allowed_origins?: string[];
}

export interface HttpUpdateMessage {
  is_spam: boolean;
}

export interface Issue {
  id: string;
  form_id?: string;
  message_id?: string;
  issue_type: string;
  issue_code: string;
  details?: string;
  dismissed: boolean;
  created_at: string;
}

export interface IssueResponse {
  id: string;
  form_id?: string;
  form_title?: string;
  message_id?: string;
  issue_type: string;
  issue_code: string;
  details?: string;
  dismissed: boolean;
  created_at: string;
}

export interface IssuesQueryParams {
  form_id?: string;
  dismissed?: boolean;
  limit: number;
  offset: number;
}

export interface IssuesResponse {
  data: IssueResponse[];
  total: number;
}

export interface JsonRedirect {
  redirect_url: string;
}

export interface Message {
  id: string;
  form_id: string;
  /** Plaintext JSON in 'none' mode; ciphertext in 'server'/'nostr' modes. */
  data: string;
  is_spam: boolean;
  spam_score: number;
  user_marked_spam: boolean;
  created_at: string;
  ip_hash: string;
  user_agent?: string;
  device_type?: string;
  browser_name?: string;
  form_view_id?: string;
  location?: LocationInfo;
  encryption_mode: string;
  /** Nostr mode: ephemeral server pubkey the user needs to decrypt. */
  encryption_pubkey?: string;
  /** Which signals fired, so an owner can be told why a message was marked. */
  signal_hits?: any;
}

export interface MessageCountByDay {
  date: string;
  message_count: number;
}

export interface MessageQueryParams {
  limit: number;
  offset: number;
  form_id?: string;
  is_spam?: boolean;
}

/**
 * Response type for messages that handles encryption modes appropriately.
 * - For 'none' and 'server' modes: data contains decrypted JSON
 * - For 'nostr' mode: data_encrypted contains the ciphertext, data is null
 */
export interface MessageResponse {
  id: string;
  form_id: string;
  /** Decrypted message data (JSON string). Present for 'none' and 'server' modes, null for 'nostr' mode. */
  data?: string;
  /** Encrypted message data. Only present for 'nostr' mode. */
  data_encrypted?: string;
  is_spam: boolean;
  spam_score: number;
  user_marked_spam: boolean;
  created_at: string;
  ip_hash: string;
  user_agent?: string;
  device_type?: string;
  browser_name?: string;
  form_view_id?: string;
  location?: LocationInfo;
  /** Encryption mode used for this message */
  encryption_mode: string;
  /** For Nostr mode: the ephemeral server pubkey for decryption */
  encryption_pubkey?: string;
}

/** Response type for paginated messages */
export interface MessagesApiResponse {
  data: MessageResponse[];
  files?: File[];
  total: number;
}

export interface MessagesResponse {
  data: Message[];
  files?: File[];
  total: number;
}

export interface NewForm {
  title: string;
  filter_spam?: boolean;
  check_challenge?: boolean;
  redirect_url?: string;
  user_id: string;
  auto_response_enabled?: boolean;
  auto_response_subject?: string;
  auto_response_text?: string;
  encryption_mode?: string;
  email_notification_type?: string;
  email_notification_format?: string;
  auto_response_format?: string;
  /** None = use plan default. */
  retention_days?: number | null;
  allowed_origins?: string[];
}

export interface NewFormView {
  form_id: string;
  ip_hash: string;
  user_agent?: string;
  referrer?: string;
  view_type: string;
  device_type?: string;
  browser_name?: string;
  traffic_source?: string;
  location?: LocationInfo;
  analytics_data?: any;
}

export interface NewFormsRecipient {
  form_id: string;
  verified_email_id: string;
}

/** Single message response with form and files */
export interface SingleMessageResponse {
  message: MessageResponse;
  form?: Form;
  files: File[];
  view?: FormView;
}

export interface UpdateForm {
  title: string;
  filter_spam: boolean;
  check_challenge: boolean;
  check_specs: boolean;
  specs?: string;
  redirect_url?: string;
  auto_response_enabled: boolean;
  auto_response_subject?: string;
  auto_response_text?: string;
  email_notification_format?: string;
  auto_response_format?: string;
  /** None = use plan default. */
  retention_days?: number | null;
  allowed_origins?: string[];
}

export interface UpdateFormSpecs {
  specs?: string;
}

export interface ViewCountByDay {
  date: string;
  view_count: number;
}

/** Encryption mode for form submissions */
export enum EncryptionMode {
  /** No encryption - data stored as plaintext */
  None = 'none',
  /** Server-side encryption with master key (AES-256-GCM) */
  Server = 'server',
  /** End-to-end encryption with user's Nostr public key (NIP-44) */
  Nostr = 'nostr',
}
